<template>
  <div>
    <vs-row>
      <vs-col vs-type="flex"vs-justify="center" vs-align="center" vs-w="12">
        <vs-navbar
        :color="colorNav"
        text-color="rgba(1,1,1,.6)"
        active-text-color="rgba(1,1,1,1)"
        class="myNavbar">
          <div slot="title">
            <vs-navbar-title>
              <img src="@/assets/logo.png" width="200" alt="">
            </vs-navbar-title>
          </div>
          <vs-navbar-item index="2">
            <a href="http://trabajo.durango.gob.mx/" ><i class="fas fa-sign-out-alt"></i> Volver</a>
          </vs-navbar-item>
      </vs-navbar>
    </vs-col>
    </vs-row>
    <div class="container mt-3">
      <div class="row">
        <div class="col-md-12">
            <h2>Trabajador (a):</h2>
            <p>
                Si tu patrón te despidió o te mandó de descanso sin pago de salarios alegando que es por motivo del COVID-19, aquí te podemos ayudar. <br>
                Es muy importante que proporciones todos los datos que te solicitamos para poder acompañarte y resolver tu problema lo más pronto posible. 
            </p>
        </div>
        <div class="col-md-12 mt-5 mb-5">
          <div class="card" >
            <div class="card-body">
                <h4 class="text-center subtitulos">Datos Personales</h4> 
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">CURP</label>
                            <input class="form-control upp" v-model.trim="curp" maxlength="18"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Nombre Completo</label>
                            <input class="form-control" v-model.trim="nombre" maxlength="50"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Teléfono</label>
                            <input class="form-control" v-model.trim="tel_trabajador"  v-mask="'###-###-####'"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Email</label>
                            <input class="form-control"  v-model.trim="email_trabajador" @blur="TheEmailBlur" maxlength="30"/>
                        </div>
                    </div>
                </div>

                <h4 class="text-center subtitulos mt-3">Datos que debes proporcionar para localizar a tu patrón</h4> 
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="">¿Conozco el rfc de mi patrón?</label><br>
                            <label for="">No / Si</label>
                             <vs-switch v-model="switch_patron"/>
                        </div>
                    </div>
                    <template v-if="!switch_patron">            
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="">Nombre de la empresa</label>
                                <input class="form-control" v-model.trim="nombre_empresa" maxlength="60"/>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">RFC</label>
                                <input class="form-control upp" v-model.trim="rfc_empresa" maxlength="13"/>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Nombre de la empresa</label>
                                <input class="form-control" v-model.trim="nombre_empresa" maxlength="60"/>
                            </div>
                        </div>
                    </template>
                </div>


                <h4 class="text-center subtitulos mt-3">Datos de contacto en los que pueda contactarse al representante de la empresa o establecimiento, o a su área de personal (Recursos Humanos)</h4> 
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Email</label>
                            <input class="form-control" v-model.trim="email_representante" maxlength="30"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Teléfono</label>
                            <input class="form-control" v-model.trim="telefono_representante" v-mask="'###-###-####'"/>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <p class="text-muted">Debe tener al menos una forma de contacto</p>
                    </div>
                </div>
                
                
                
                <h4 class="text-center subtitulos mt-3">Domicilio de la empresa o establecimiento</h4> 
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Calle</label>
                            <input class="form-control" v-model.trim="calle_empresa" maxlength="30"/>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Número exterior</label>
                            <input class="form-control" v-model.trim="exterior_empresa" maxlength="5"/>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="">Número interior</label>
                            <input class="form-control" v-model.trim="interior_empresa" maxlength="5"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Código Postal</label>
                            <input class="form-control" v-model.trim="cp_empresa" v-on:keyup="getColonias()" maxlength="5"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Colonia</label>
                            <select class="form-control"  v-model="colonia_empresa">
                                <option value="x">Selecciona una colonia</option>
                                <option v-for="(item, index) in colonias" :key="index" :value="item">{{item}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Entidad</label>
                            <input class="form-control" v-model.trim="entidad_empresa" maxlength="60" disabled/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Municipio</label>
                            <input class="form-control" v-model.trim="municipio_empresa" maxlength="60" disabled/>
                        </div>
                    </div>
                </div>
                
                
                
                <h4 class="text-center subtitulos mt-3">Actividad del patrón / Actividad del trabajador (a)</h4> 
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">¿A qué se dedica la empresa?</label>
                            <input class="form-control" v-model.trim="giro_empresa" maxlength="30"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">¿Puesto dentro de la empresa?</label>
                            <input class="form-control" v-model.trim="puesto_empresa" maxlength="30"/>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Fecha de tu ingreso con el patrón</label>
                            <datetime input-class="form-control" type="date" value-zone="America/Toronto" format="yyyy-MM-dd" v-model="fecha_ingreso"></datetime>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Último salario percibido</label>
                            <select class="form-control" v-model="salario_empresa">
                                    <option value="x" selected="">Selecciona una opción</option>
                                    <option value="Hasta 5,000">Hasta 5,000</option>
                                    <option value="Más de 5,000 hasta 10,000">Más de 5,000 hasta 10,000</option>
                                    <option value="Más de 10,000 hasta 15,000">Más de 10,000 hasta 15,000</option>
                                    <option value="Más de 15,000 hasta 20,000">Más de 15,000 hasta 20,000</option>
                                    <option value="Más de 20,000">Más de 20,000</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Días de descanso a la semana</label>
                            <input type="number" max="6" min="0" class="form-control" v-model="descanso_empresa">
                        </div>
                    </div>
                </div>
                
                
                
                <h4 class="text-center subtitulos mt-3">Breve descripción del problema</h4> 
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">¿Qué te dijo?</label>
                            <vs-textarea counter="250" :counter-danger.sync="counterDangerFair" v-model.trim="problema" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">¿Cuándo te lo dijo?</label>
                            <datetime input-class="form-control" type="datetime" value-zone="America/Toronto" format="yyyy-MM-dd HH:mm" v-model="fecha_problema"></datetime>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="">¿En dónde te lo dijo o a través de que medio?</label>
                            <vs-textarea counter="250" :counter-danger.sync="counterDangerFair" v-model.trim="medio_problema" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">¿Te avisó?</label><br>
                            <label for="">No / Si</label>
                             <vs-switch v-model="switch_aviso"/>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">¿Firmaste algún documento u hoja en blanco?</label><br>
                            <label for="">No / Si</label>
                             <vs-switch v-model="switch_firmo"/>
                        </div>
                    </div>
                </div>


                <h4 class="text-center subtitulos mt-3">Sube tu documentación</h4> 
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">Por favor sube archivos de tipo imagen JPG con un peso máximo de 2 Mb</label>
                            <input id='inputFile' @change="previewFiles" ref="inputFile" type='file' />
                        </div>
                    </div>
                    <div class="col-lg-6 text-center" v-if="fileList.length >0">
                        <h5>Mi ID</h5>
                        <ul class="list-group" >
                            <li class="list-group-item" v-for="(item, index) in fileList">
                                <img :src="previewUrl" v-if="previewUrl" width="150">
                                <p>{{item.name}}</p>
                            </li>
                        </ul>
                        <vs-button class="mt-3" color="rgb(187, 138, 200)" type="relief" size="small" @click="clearEv()">Limpiar</vs-button>

                    </div>
                </div>
                
                <h4 class="text-center subtitulos mt-3">Antes de terminar</h4> 
                <div class="row">
                    <div class="col-md-6 align-self-center">
                        <p>Amigo trabajador, al terminar de llenar el formulario recibirás un archivo pdf con un <strong>número de folio</strong>. Este número sirve para llevar un seguimiento
                        de tu caso, te puedes comunicar a nuestros números de contacto para solicitar información. Incluso puedes imprimir tu folio.</p>
                    </div>
                    <div class="col-lg-6 text-center">
                        <h5>Ejemplo</h5>
                        <img class="img-fluid" src="@/assets/folio.jpg" alt="">

                    </div>
                </div>


                <vs-button :color="colorEnviar" @click="enviarTerminar"  type="relief">Terminar y enviar</vs-button>
            </div>
          </div>
        </div>
      </div>


  

    </div>

    <vs-popup title="Edit" :active.sync="popupFair">
        <div class="continer">
          <div class="row">
            <div class="col-md-12">
                <h4 ><i class="fa fa-pencil-alt" aria-hidden="true"></i> Update a Fair with id #{{e_fairId}}</h4> 
                <div class="form-group">
                    <label for="">Fair Name</label>
                    <input class="form-control" v-model.trim="e_fairName" maxlength="60"/>
                </div>
                <div class="form-group">
                    <label for="">Fair Description</label>
                    <vs-textarea counter="150" :counter-danger.sync="counterDangerFair" v-model.trim="e_fairDesc" />
                </div>
                <div class="form-group">
                    <label for="">Category</label>
                    <select class="form-control" v-model="e_fairCategory">
                        <option value="x">Select a category</option>
                        <option v-for="(item, index) in allCategories" :key="index" :value="item.id">{{item.category}}</option>
                    </select>
                </div>
                <p class="text-muted">Note: If you want to update the dates you only have to fill in the fields, otherwise leave them blank</p>
                <hr/>
                <div class="form-group">
                    <label for="">Start Date - <strong>{{e_fairDatetime}}</strong></label>
                    <datetime input-class="form-control" type="datetime" value-zone="America/Toronto" format="yyyy-MM-dd HH:mm" v-model="e_fairDatetime"></datetime>
                </div>
                <div class="form-group">
                    <label for="">End Date - <strong>{{e_fairDatetime2}}</strong></label>
                    <datetime input-class="form-control" type="datetime" value-zone="America/Toronto" format="yyyy-MM-dd HH:mm" v-model="e_fairDatetime2"></datetime>
                </div>
                <vs-button type="relief" @click="updFair()">Save Changes</vs-button> 
                <!-- <p class="text-center mt-3">To delete a Fair just click <vs-button @click="befDelFair()" color="danger">here</vs-button> and  remember if fair with id #{{e_fairId}} is erased you will remove {{totalBooths}} of registered booths.</p> -->
            </div>
          </div>
        </div>
    </vs-popup>

    <vs-popup title="Delete" :active.sync="popupFairDel">
        <div class="continer">
          <div class="row">
            <div class="col-md-12 text-center">
                <h4><i class="fa fa-pencil-alt" aria-hidden="true"></i> Are you sure?</h4> 
                <vs-button class="mr-3" color="danger" type="relief" @click="delFair()">Yes, delete it</vs-button> 
                <vs-button color="dark"  type="relief" @click="delFairCancel()">No, cancel</vs-button> 
            </div>
          </div>
        </div>
    </vs-popup>

    
<footer class="mainfooter" role="contentinfo">
    <div class="footer-middle">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12 text-center">
          <!--Column1-->
          <div class="footer-pad">
            <h4>Teléfonos</h4>
            <ul class="list-unstyled">
              <li><a href="#"></a></li>
              <li><i class="fas fa-phone"></i> 618 137 4461</li>
              <li><i class="fas fa-phone"></i> 618 137 4462</li>
              <li><i class="fas fa-phone"></i> 618 137 4481</li>
              <li><i class="fas fa-phone"></i> 618 137 4481</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12 copy text-center">
            <p>
                <span class="mr-3"><i class="fab fa-facebook-f"></i> <a href="https://www.facebook.com/STyPSDurango/"> @STYPSDurango</a> </span> 
                <span class="mr-3"><i class="fab fa-twitter"></i> <a href="https://twitter.com/stypsdgo"> @stypsdgo</a> </span> 
                <span><i class="fas fa-globe"></i> <a href="http://trabajo.durango.gob.mx/"> www.trabajo.durango.gob.mx</a></span> 
                
            </p>
            <p>Gobierno del Estado de Durango <br>
            <a href="http://trabajo.durango.gob.mx/wp-content/uploads/sites/10/2019/06/AVISO-DE-PRIVACIDAD-INTEGRAL-DIL.pdf" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a></p>
          </div>
      </div>
  
  
    </div>
    </div>
  </footer>
    

  </div>

</template>

<script>
import {firebaseApp} from '../fb';
import router from '../router';
import validator from "validator";
import axios from "axios";
import { Datetime } from 'vue-datetime';

export default {
  name: 'covid19',
  components: {
    datetime: Datetime
  },
  data() {
    return {
        colorNav:"#ffffff",
        colorEnviar:'#003A70',
        previewUrl:'',

        curp:'',
        nombre:'',
        tel_trabajador:'',
        email_trabajador:'',

        switch_patron:false,
        empresa:'',
        rfc_empresa:'',
        nombre_empresa:'',
        email_representante:'',
        telefono_representante:'',
        calle_empresa:'',
        exterior_empresa:'',
        interior_empresa:'',
        cp_empresa:'',
        colonia_empresa:'x',
        entidad_empresa:'',
        municipio_empresa:'',
        giro_empresa:'',
        puesto_empresa:'',
        fecha_ingreso:'',
        salario_empresa:'x',
        descanso_empresa:'',
        problema:'',
        fecha_problema:'',
        medio_problema:'',
        switch_aviso:false,
        switch_firmo:false,

        colonias:[],
        fileList:[],







        allCategories:[],
        allCategories2:[],
        allCountries:[],
        allFairs:[],
        allActiveFairs:[],
        allEx:[],
        allApps:[],
        allAdmins:[],

        passwordFieldType: 'password',
        faiconPass: 'fa fa-eye-slash',
        showExhibitors:false,

        adminName:'',
        adminType:'x',
        adminEmail:'',
        adminPass:'',
        adminConfirm:'',
        
        e_adminUid:'',
        e_adminId:'',
        e_adminName:'',
        e_adminType:'x',
        e_adminEmail:'',
        e_adminPass:'',
        e_adminConfirm:'',
        e_adminStatus:'',
        popupAdmins:false,
        popupAdminDel:false,
        confirmAdminDel:'',

        popupCats:false,
        catName:'',
        e_catName:'',
        e_catId:'',
        e_catStatus:'x',

        showApplicants:false,
        appName:'',
        appLastName:'',
        appFair:'x',
        appCategory:'x',
        appEmail:'',
        appPass:'',
        appConfirm:'',

        counterDangerFair:false,
        fairName:'',
        fairDesc:'',
        fairDatetime:'',
        fairDatetime2:'',
        fairCategory:'x',

        popupFair:false,
        popupFairDel:false,
        popupEx:false,
        popupExDel:false,
        popupApps:false,
        popupAppDel:false,
        confirmExDel:'',
        confirmAppDel:'',

        e_appId:'',
        e_appName:'',
        e_appLastName:'',
        e_appCategory:'x',
        e_appFair:'x',
        e_appStatus:'x',
        e_appEmail:'',
        e_appPass:'',
        e_appConfirm:'',

        e_counterDangerFair:false,
        e_fairId:'',
        e_fairName:'',
        e_fairDesc:'',
        e_fairDatetime:'',
        e_fairDatetime2:'',
        e_fairCategory:'x',
        totalBooths:'x',

        e_exId:'',
        e_exSchool:'',
        e_exName:'',
        e_exLastName:'',
        e_exCountry:'x',
        e_exCategory:'x',
        e_exStatus:"x",
        e_exEmail:'',
        e_exPass:'',
        e_exConfirm:'',

        exSchool:'',
        exName:'',
        exLastName:'',
        exCountry:'x',
        exCategory:'x',
        exEmail:'',
        exPass:'',
        exConfirm:'',

        activeItem: 0,
        colorx:'#fada8a',
        showFairs:false,
        showConfigs:false,

        loguedId:'',
        loguedUid:'',
        loguedName:'',
        loguedType:'',
        loguedPass:'',
        loguedConfirm:''
       
    }
  },
  mounted() {
    this.toggleBodyClass('remove', 'custom-bg');
    this.openLoadingBackground();    

  },
  methods: {



    TheEmailBlur(){
        var vm = this;
        var email_trabajador = this.email_trabajador.toLowerCase();
        if(email_trabajador.length>0){
          firebaseApp.database().ref('reporteCovid')
          .orderByChild('email_trabajador')
          .equalTo(email_trabajador)
          .once('value', function (snapshot) {
            var data = snapshot.val();
            if(data){
                vm.sendNotify('Error',`Este email ya fue registrado anteriormente`, 'danger');
                vm.email_trabajador = ''
                return;
            }
          })
        }
      },

    enviarTerminar(){

        var vm = this
        if(vm.curp.length !=18){
            vm.sendNotify('Error',`El campo CURP está vacío`, 'danger');
            return;
        }
        if(vm.nombre.length ==0){
            vm.sendNotify('Error',`El nombre está vacío`, 'danger');
            return;
        }
        if(vm.nombre.length >50){
            vm.sendNotify('Error',`El campo nombre es demasiado largo`, 'danger');
            return;
        }
        if(vm.tel_trabajador.length !=12){
            vm.sendNotify('Error',`Formato de teléfono en datos personales es incorrecto`, 'danger');
            return;
        }
        if (!validator.isEmail(vm.email_trabajador)) {
            vm.sendNotify("Error", "Email en datos personales con formato incorrecto", "danger", "highlight_off");
            return;
        }
        if (vm.email_trabajador.length > 50) {
            vm.sendNotify("Error", "Email en datos personales es demasiado largo", "danger", "highlight_off");
            return;
        }
        
        if (vm.rfc_empresa.length >0 &&  vm.rfc_empresa.length <13 ) {
            vm.sendNotify("Error", "El rfc debe contener 13 caracteres", "danger", "highlight_off");
            return;
        }else{
            var rfc_empresa = vm.rfc_empresa;
        }

        if (vm.rfc_empresa.length ==0 ) {
            var rfc_empresa = 'n/a';
        }

        if (vm.nombre_empresa.length ==0 ) {
            vm.sendNotify("Error", "El nombre de la empresa está vacío", "danger", "highlight_off");
            return;
        }
        if (vm.nombre_empresa.length >60 ) {
            vm.sendNotify("Error", "El nombre de la empresa es demasiado largo", "danger", "highlight_off");
            return;
        }

        if (vm.email_representante.length > 0) {
            if (!validator.isEmail(vm.email_representante)) {
                vm.sendNotify("Error", "Email en contacto de la empresa con formato incorrecto", "danger", "highlight_off");
                return;
            }else{
                var email_representante = vm.email_representante.toLowerCase();
            }
        }else{
            var email_representante = 'n/a'
        }

        if (vm.telefono_representante.length > 0) {
            if(vm.telefono_representante.length !=12){
                vm.sendNotify('Error',`Formato de teléfono en contacto de la empresa es incorrecto`, 'danger');
                return;
            }else{
                var telefono_representante = vm.telefono_representante
            }
        }
        if (vm.telefono_representante.length == 0) {
            var telefono_representante = 'n/a'
        }
        
        if (vm.telefono_representante.length == 0  && vm.email_representante.length == 0) {
            vm.sendNotify('Error',`Debes proporcionar al menos un dato de contacto de tu empresa`, 'danger');
            return;
        }

        if (vm.calle_empresa.length == 0 ) {
            vm.sendNotify('Error',`La calle de la empresa está vacía`, 'danger');
            return;
        }
        if (vm.exterior_empresa.length == 0 ) {
            vm.sendNotify('Error',`El número exterior de la empresa está vacío`, 'danger');
            return;
        }
        if (vm.exterior_empresa.length >5 ) {
            vm.sendNotify('Error',`El número exterior de la empresa es demasiado largo`, 'danger');
            return;
        }
        if (vm.interior_empresa.length ==0 ) {
            var interior_empresa = 'n/a'
        }else{
            var interior_empresa = vm.interior_empresa
        }
        if (vm.cp_empresa.length !=5 ) {
            vm.sendNotify('Error',`Por favor teclea un CP correcto, asi podremos encontrar la colonia, estado y municipio de tu empresa`, 'danger');
            return;
        }
        if (vm.cp_empresa.length ==0 ) {
            vm.sendNotify('Error',`El cp de la empresa está vacío`, 'danger');
            return;
        }
        if (vm.colonia_empresa =='x' ) {
            vm.sendNotify('Error',`Selecciona una colonia`, 'danger');
            return;
        }
        if (vm.giro_empresa.length ==0 ) {
            vm.sendNotify('Error',`El giro de la empresa está vacío`, 'danger');
            return;
        }
        if (vm.giro_empresa.length ==30 ) {
            vm.sendNotify('Error',`El giro de la empresa es demasiado largo`, 'danger');
            return;
        }
        if (vm.puesto_empresa.length ==0 ) {
            vm.sendNotify('Error',`El puesto de la empresa está vacío`, 'danger');
            return;
        }
        if (vm.puesto_empresa.length ==30 ) {
            vm.sendNotify('Error',`El puesto de la empresa es demasiado largo`, 'danger');
            return;
        }
        if (vm.fecha_ingreso.length ==0 ) {
            vm.sendNotify('Error',`Selecciona fecha en que ingresaste a la empresa`, 'danger');
            return;
        }
        if (vm.salario_empresa =='x' ) {
            vm.sendNotify('Error',`Selecciona el salario en tu empresa`, 'danger');
            return;
        }
        if (!validator.isInt(vm.descanso_empresa)) {
            vm.sendNotify("Error", "Dias de descanso con formato incorrecto, deben ser solo números", "danger", "highlight_off");
            return;
        }
        if (vm.descanso_empresa >6 ) {
            vm.sendNotify('Error',`No es posible esa cantidad de descanso`, 'danger');
            return;
        }
        if (vm.problema.length ==0 ) {
            vm.sendNotify('Error',`Indica ¿Qué te dijo?`, 'danger');
            return;
        }
        if (vm.problema.length >250 ) {
            vm.sendNotify('Error',`Descripción del problema demasiado larga`, 'danger');
            return;
        }
        if (vm.fecha_problema.length ==0 ) {
            vm.sendNotify('Error',`Selecciona fecha del problema`, 'danger');
            return;
        }
        if (vm.medio_problema.length ==0 ) {
            vm.sendNotify('Error',`Indica los medios que uso para notificarte y donde`, 'danger');
            return;
        }
        if (vm.medio_problema.length >250 ) {
            vm.sendNotify('Error',`Descripción de medios y donde es demasiado larga`, 'danger');
            return;
        }

        if (vm.switch_aviso) {
            var switch_aviso = "SI"
        }else{
            var switch_aviso = "NO"
        }

        if (vm.switch_firmo) {
            var switch_firmo = "SI"
        }else{
            var switch_firmo = "NO"
        }
        if (vm.fileList.length == 0){
              this.sendNotify('Error','Es necesario que proporciones tu identificación', 'danger');
              return;
        }

        if(vm.municipio_empresa=="Gómez Palacio"){
            var mun = '0';
        }else{
            var mun ='1';
        }

        vm.openLoadingBackground();

        var  idf = Date.now();
        firebaseApp.database().ref('reporteCovid/').push({
            folio:idf,
            curp: vm.curp,
            nombre: vm.nombre,
            tel_trabajador: vm.tel_trabajador,
            email_trabajador: vm.email_trabajador,
            rfc_empresa: rfc_empresa,
            nombre_empresa: vm.nombre_empresa,
            email_representante: email_representante,
            telefono_representante: telefono_representante,
            calle_empresa: vm.calle_empresa,
            exterior_empresa: vm.exterior_empresa,
            interior_empresa: interior_empresa,
            cp_empresa: vm.cp_empresa,
            colonia_empresa: vm.colonia_empresa,
            municipio_empresa: vm.municipio_empresa,
            entidad_empresa: vm.entidad_empresa,
            giro_empresa: vm.giro_empresa,
            puesto_empresa: vm.puesto_empresa,
            fecha_ingreso: vm.fecha_ingreso,
            salario_empresa: vm.salario_empresa,
            descanso_empresa: vm.descanso_empresa,
            problema: vm.problema,
            fecha_problema: vm.fecha_problema,
            medio_problema: vm.medio_problema,
            switch_aviso: switch_aviso,
            switch_firmo: switch_firmo,
        })
        .then((snap)=>{
            const key = snap.key;
            vm.fileList.forEach(function (file) {
                firebaseApp.storage().ref(`imagenes/${key}/${file.name}`).put(file)
                .then(function(snapshot) {
                    firebaseApp.storage().ref(`imagenes/${key}/${file.name}`).getDownloadURL()
                    .then(function(downloadURL) {
                        axios.post('http://defensadeltrabajo.durango.gob.mx/sendMail.php ', {
                            folio:idf,
                            curp: vm.curp,
                            nombre: vm.nombre,
                            tel_trabajador: vm.tel_trabajador,
                            email_trabajador: vm.email_trabajador,
                            rfc_empresa: rfc_empresa,
                            nombre_empresa: vm.nombre_empresa,
                            email_representante: email_representante,
                            telefono_representante: telefono_representante,
                            calle_empresa: vm.calle_empresa,
                            exterior_empresa: vm.exterior_empresa,
                            interior_empresa: interior_empresa,
                            cp_empresa: vm.cp_empresa,
                            colonia_empresa: vm.colonia_empresa,
                            municipio_empresa: vm.municipio_empresa,
                            entidad_empresa: vm.entidad_empresa,
                            giro_empresa: vm.giro_empresa,
                            puesto_empresa: vm.puesto_empresa,
                            fecha_ingreso: vm.fecha_ingreso,
                            salario_empresa: vm.salario_empresa,
                            descanso_empresa: vm.descanso_empresa,
                            problema: vm.problema,
                            fecha_problema: vm.fecha_problema,
                            medio_problema: vm.medio_problema,
                            switch_aviso: switch_aviso,
                            switch_firmo: switch_firmo,
                            urlImagen:downloadURL,
                            mun:mun
                        })
                        .then(function (response) {
                            console.log(response)
                            if(response.data.message=='success'){
                                var dApi2=`http://defensadeltrabajo.durango.gob.mx/pdf-tools/pdf/imprime_ticket.php?idf=${idf}`
                                window.open(dApi2, 'Download'); 
                                vm.sendNotify("Success", "Los datos han sido enviados, a la brevedad te atenderemos, recuerda guardar tu folio", "success", "highlight_off");
                                setTimeout( ()=> {
                                    vm.curp = ''
                                    vm.nombre = ''
                                    vm.tel_trabajador = ''
                                    vm.email_trabajador = ''
                                    vm.switch_patron = false
                                    vm.rfc_empresa = ''
                                    vm.nombre_empresa = ''
                                    vm.email_representante = ''
                                    vm.telefono_representante = ''
                                    vm.calle_empresa = ''
                                    vm.exterior_empresa = ''
                                    vm.interior_empresa = ''
                                    vm.cp_empresa = ''
                                    vm.colonias =[]
                                    vm.colonia_empresa ='x'
                                    vm.entidad_empresa =''
                                    vm.municipio_empresa =''
                                    vm.giro_empresa = ''
                                    vm.puesto_empresa = ''
                                    vm.fecha_ingreso = ''
                                    vm.salario_empresa = 'x'
                                    vm.descanso_empresa = ''
                                    vm.problema = ''
                                    vm.fecha_problema = ''
                                    vm.medio_problema = ''
                                    vm.switch_aviso = false
                                    vm.switch_firmo = false
                                    vm.clearEv()
                                }, 3000);
                            }else{
                                vm.sendNotify("Error", "Something went wrong", "error", "highlight_off");
                            }
                        })
                        .catch(function () {
                            vm.sendNotify("Error", "Something went wrong", "error", "highlight_off");
                        });  
                    });
                })
                .catch((error)=>{
                    this.sendNotify('Error','Ocurrió un error, por favor intentalo más tarde', 'danger');
                    return;
                })
                
             });

        })
        .catch((error)=>{
            vm.sendNotify('Error','Ocurrió un error, por favor intentalo más tarde', 'danger');
            return;
        });  
    },
      

    clearEv(){
        this.fileList= '';
    },

    previewFiles(event){
        var vm = this
          this.fileList=[];
          var format = ['image/jpeg','image/png'];
          if(inputFile.files.length > 5 ){
              this.$refs.inputFile.value= ''
              this.sendNotify('Error','Solo es permitido 1 archivo1 por reporte', 'danger');
              return;
          }
          for (var i = 0; i < this.$refs.inputFile.files.length; i++) {
              if(format.indexOf(inputFile.files[i].type) >=0){
                  if(inputFile.files[i].type== 'video/x-ms-wmv' || inputFile.files[i].type== 'video/mp4' ){
                      if(inputFile.files[i].size/1024 > 5500){
                          this.sendNotify('Advertencia',`Solo videos con un tamaño máximo de 5 MB son aceptados, el video ${inputFile.files[i].name} no es válido`, 'warning');

                      }else{
                          this.fileList.push(inputFile.files[i]);
                      }
                  }else{
                      if(inputFile.files[i].size/1024 > 2000){
                          this.sendNotify('Advertencia',`Solo imagenes con un tamaño máximo de 2 MB son aceptadas, la imagen ${inputFile.files[i].name} no es válida`, 'warning');

                      }else{
                          this.fileList.push(inputFile.files[i]);
                          const fileUp = event.target.files[0]
                            if (!fileUp) {
                                return false
                            }
                            if (!fileUp.type.match('image.*')) {
                                return false
                            }
                            const reader = new FileReader()
                            reader.onload = function (e) {
                                vm.previewUrl = e.target.result
                            }
                            reader.readAsDataURL(fileUp)
                      }
                  }
              }else{
                  this.sendNotify('Advertencia',`El archivo ${inputFile.files[i].name} no es válido`, 'warning');
              }
          }
          this.$refs.inputFile.value= '';
      },


    getColonias(){
        var vm = this
        if(vm.cp_empresa.length==5){
            axios.get(`https://api-sepomex.hckdrk.mx/query/info_cp/${vm.cp_empresa}?type=simplified`).then(({ data }) => {
                if(data){
                    vm.colonias =data.response.asentamiento
                    vm.entidad_empresa =data.response.estado
                    vm.municipio_empresa =data.response.municipio
                }else{
                    vm.sendNotify("Error", "No data to download", "danger", "highlight_off");
                    return;
                }
            })
        }else{
            vm.colonias =[]
            vm.colonia_empresa ='x'
            vm.entidad_empresa =''
            vm.municipio_empresa =''
        }
    },


     toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
            
            el.classList.add(className);
        } else {
            el.classList.remove(className);
        }
    },
    openLoadingBackground(){
      this.$vs.loading({background:'rgb(0,0,0,0.8)',color:'rgb(255, 255, 255)'})
      setTimeout( ()=> {
        this.$vs.loading.close()
        this.loading=true
      }, 3400);
    },
    checkLogin(){
      firebaseApp.auth().onAuthStateChanged(user =>{
      if(user){
        router.push('/covid19')     
      }else{
        router.replace('/covid19')
      }
      })
    },
    sendNotify(title, text, color, icon) {
      this.$vs.notify({
        title: title,
        text: text,
        color: color,
        icon: icon
      });
    },

  },
}
</script>

<style>
    body{
        background-color: #f2f8fa!important;
    }
    .azul-claro{
        color: #2bb8e8 !important;
    }

    .subtitulos {
        background: #003A70!important;
        font-weight: 600;
        padding: 1rem;
        color: white;
        text-align: center;
        font-size: medium;
    }

    .upp {
        text-transform: uppercase;
    }
     .vs-pagination--ul {
        margin-bottom: 0px !important;
    }

    .vs-table--search{
        margin-right: 10px !important;
    }

    .badge{
        border-radius: 1rem !important;
        font-size: 70% !important;
        font-weight: lighter !important;
    }

    .vs-table--search-input {
        font-size: .9rem !important;
    }
    .vs-table--header, .vs-table--search {
        background-color: #e4eaff !important;
    }

    
/*FOOTER*/

footer {
  background: #16222A;
  background: -webkit-linear-gradient(59deg, #3A6073, #16222A);
  background: linear-gradient(59deg, #3A6073, #16222A);
  color: white;
  margin-top:100px;
}

footer a {
  color: #fff;
  font-size: 14px;
  transition-duration: 0.2s;
}

footer a:hover {
  color: #FA944B;
  text-decoration: none;
}

.copy {
  font-size: 12px;
  padding: 10px;
  border-top: 1px solid #FFFFFF;
}

.footer-middle {
  padding-top: 2em;
  color: white;
}


/*SOCİAL İCONS*/

/* footer social icons */

ul.social-network {
  list-style: none;
  display: inline;
  margin-left: 0 !important;
  padding: 0;
}

ul.social-network li {
  display: inline;
  margin: 0 5px;
}


/* footer social icons */

.social-network a.icoFacebook:hover {
  background-color: #3B5998;
}

.social-network a.icoLinkedin:hover {
  background-color: #007bb7;
}

.social-network a.icoFacebook:hover i,
.social-network a.icoLinkedin:hover i {
  color: #fff;
}

.social-network a.socialIcon:hover,
.socialHoverClass {
  color: #44BCDD;
}

.social-circle li a {
  display: inline-block;
  position: relative;
  margin: 0 auto 0 auto;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  text-align: center;
  width: 30px;
  height: 30px;
  font-size: 15px;
}

.social-circle li i {
  margin: 0;
  line-height: 30px;
  text-align: center;
}

.social-circle li a:hover i,
.triggeredHover {
  -moz-transform: rotate(360deg);
  -webkit-transform: rotate(360deg);
  -ms--transform: rotate(360deg);
  transform: rotate(360deg);
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -o-transition: all 0.2s;
  -ms-transition: all 0.2s;
  transition: all 0.2s;
}

.social-circle i {
  color: #595959;
  -webkit-transition: all 0.8s;
  -moz-transition: all 0.8s;
  -o-transition: all 0.8s;
  -ms-transition: all 0.8s;
  transition: all 0.8s;
}

.social-network a {
  background-color: #F9F9F9;
}

</style>